export default {
    message: {
        hello: 'hello world'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js